import { ReactNode } from "react";

type Props = {
  children: ReactNode;
};
export default function BidFavoriteSearch({ children }: Props) {
  return <div>{children}</div>;
}
